/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { createSlice } from '@reduxjs/toolkit';
import { STORAGE_KEYS, TEMP_STORAGE_KEYS, WEBPAGE_TITLE_DEFAULT } from '../../constants/main';

const initialState = {
  isSidebarOpen: JSON.parse(window.localStorage.getItem(STORAGE_KEYS.IS_SIDEBAR_OPEN)) === true || true,
  isFullScreenMode: false,
  pageTitle: WEBPAGE_TITLE_DEFAULT,
  footerContent: null,
  observatorySearchParams: JSON.parse(window.localStorage.getItem(TEMP_STORAGE_KEYS.OBSERVATORY_SEARCH_PARAMS)) || {},
  hasVisitedObservatory: JSON.parse(window.localStorage.getItem(TEMP_STORAGE_KEYS.HAS_VISITED_OBSERVATORY)) || false,
  isPreviewWidgetCollapsed: JSON.parse(window.localStorage.getItem(TEMP_STORAGE_KEYS.IS_PREVIEW_WIDGET_COLLAPSED)) || false
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    toggleSidebarOpen: (state, action) => {
      window.localStorage.setItem(STORAGE_KEYS.IS_SIDEBAR_OPEN, JSON.stringify(action.payload));

      return {
        ...state,
        isSidebarOpen: action.payload
      };
    },

    toggleFullScreenMode: (state, action) => ({
      ...state,
      isFullScreenMode: action.payload !== undefined ? action.payload : !state.isFullScreenMode
    }),

    setPageTitle: (state, action) => ({
      ...state,
      pageTitle: action.payload
    }),

    setFooterContent: (state, action) => ({
      ...state,
      footerContent: action.payload
    }),

    setHasVisitedObservatory: (state, action) => {
      window.localStorage.setItem(TEMP_STORAGE_KEYS.HAS_VISITED_OBSERVATORY, JSON.stringify(action.payload));
      return {
        ...state,
        hasVisitedObservatory: action.payload
      };
    },
    togglePreviewWidgetCollapsed: (state, action) => {
      window.localStorage.setItem(TEMP_STORAGE_KEYS.IS_PREVIEW_WIDGET_COLLAPSED, JSON.stringify(action.payload));
      return {
        ...state,
        isPreviewWidgetCollapsed: action.payload
      };
    },
    setObservatorySearchParams: (state, action) => {
      window.localStorage.setItem(TEMP_STORAGE_KEYS.OBSERVATORY_SEARCH_PARAMS, JSON.stringify(action.payload));

      return {
        ...state,
        observatorySearchParams: action.payload
      };
    },

    reset: () => {
      return {
        ...initialState
      };
    }
  }
});

export const globalActions = globalSlice.actions;
export default globalSlice.reducer;
